// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + ({"236":"c20f72b9","546":"020d8314"}[chunkId] || chunkId) + "." + {"90":"ea111d676a177813","205":"a4c8de620d113a19","236":"d13f336641d63847","546":"4372e31e782ee5f9","879":"f9ca21e18ab4e6ee"}[chunkId] + ".js";
};